<iframe
  *ngIf="url"
  #iframe
  [src]="url"
  title="Preview"
  [style.height.px]="height"
  (load)="onIframeLoad()"
></iframe>
